import { Component, OnInit } from "@angular/core";
import { ApiHandlerService } from "src/app/shared/services/api-handler.service";
import { API } from "src/app/shared/services/endpoints";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  //declare varible here...
  public sliderInterval;
  public appPreviewId = 1;
  public userTestiId = 1;
  constructor(public _service: ApiHandlerService) {}

  activeTest: any;
  faq: Array<any>;
  pageData: any;

  appPreview(id) {
    console.log('app preview testing')
    this.appPreviewId = id;
    // document.getElementById("ngb-tab-"+(id-1)).click();
    var body = document.body;
    if (id == 2) {
      body.classList.add("driver-body-f");
    } else {
      body.classList.remove("driver-body-f");
    }
  }

  userTesti(id) {
    clearTimeout(this.sliderInterval);
    this.activeTest = this.testimonial.find((x) => id === x._id);
    this.userTestiId = this.activeTest._id;
    let index = 0;
    this.sliderInterval = setInterval(() => {
      this.activeTest = this.testimonial[index];
      this.userTestiId = this.activeTest._id;
      if (index === this.testimonial.length - 1) index = 0;
      else index++;
    }, 3000);
  }

  ngOnInit(): void {
    let index = 0;
    this.sliderInterval = setInterval(() => {
      this.activeTest = this.testimonial[index];
      this.userTestiId = this.activeTest._id;
      if (index === this.testimonial.length - 1) index = 0;
      else index++;
    }, 3000);
    this.getData();
// Correct setTimeout syntax
    setTimeout(() => this.appPreview(2), 1000);
    setTimeout(() => this.appPreview(1), 2000);

    // this.appPreview(2)
  }

  ngAfterViewInit() {
    let footer = document.getElementsByTagName("footer")[0];
    footer.classList.remove("without-cars");

    // var button1 = document.getElementById("ngb-tab-0");
    // button1.addEventListener("click",()=>{
    //     this.appPreview(1)
    // },false);
    // var button2 = document.getElementById("ngb-tab-1");
    // button2.addEventListener("click",()=>{
    //     this.appPreview(2)
    // },false);
  }
  ngOnDestroy() {
    var body = document.body;
    body.classList.remove("driver-body-f");
    let footer = document.getElementsByTagName("footer");
    footer[0].classList.add("without-cars");
    if (footer[1]) {
      footer[1].classList.add("without-cars");
    }
  }

  public pageHomeData: any;
  public testimonial: Array<any>;
  getData() {
    var apiData = {
      page: "home",
    };
    this._service
      .apiPost(API.CMS_ENDPOINTS.GET_PAGE, apiData)
      .subscribe((resp) => {
        this.pageHomeData = resp.data.page;
        this.testimonial = resp.data.testimonial.splice(0, 8);
        this.faq = resp.data.faq;
        this.pageData = resp.data.woofferwork;
      });
  }

  get homePageImage(){
    return this.pageHomeData?.image
  }
}
